<div class="form-box-header">
    <span class="material-symbols-rounded" *ngIf="icon">{{ icon }}</span>
    <h5 *ngIf="title">{{ title }}</h5>
    <p *ngIf="text">{{ text }}</p>
</div>
